import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  component: {
    display: "flex",
    alignItems: "center",
    textTransform: "initial",
    padding: "0px"
  },
  content: {},
  icons: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "4px"
  },
  iconUp: {
    position: "relative",
    width: "12px",
    height: "12px",
    opacity: "0.2",
    "& *": {
      position: "absolute",
      top: "-1px",
      left: "-4px",
      width: "20px",
      height: "20px"
    }
  },
  iconDown: {
    position: "relative",
    width: "12px",
    height: "12px",
    opacity: "0.2",
    "& *": {
      position: "absolute",
      top: "-7px",
      left: "-4px",
      width: "20px",
      height: "20px"
    }
  },
  iconSort: {
    opacity: "initial"
  }
}));
